// Types cho hệ thống tạo ma trận đề kiểm tra

export interface QuestionCell {
  soCauYeuCau: number      // Số câu người dùng nhập
  soCauCoSan: number       // Số câu có trong database
  isValid: boolean         // Có đủ câu không
}

export interface DangToan {
  tenDang: string

  // TNKQ - Trắc nghiệm khách quan
  tnkq: {
    nhieuLuaChon: {      // 0.25 điểm/câu
      biet: QuestionCell
      hieu: QuestionCell
      vanDung: QuestionCell
    }
    dungSai: {           // 1 điểm/câu (4 lệnh)
      biet: QuestionCell
      hieu: QuestionCell
      vanDung: QuestionCell
    }
    traLoiNgan: {        // 0.5 điểm/câu
      biet: QuestionCell
      hieu: QuestionCell
      vanDung: QuestionCell
    }
  }

  // Tự luận (1.0 điểm/câu)
  tuLuan: {
    biet: QuestionCell
    hieu: QuestionCell
    vanDung: QuestionCell
  }
}

export interface ExamMatrixRow {
  id: string
  stt: number
  lop: number
  chuong: number
  bai: number
  chuDe: string
  baiHoc: string

  cacDang: DangToan[]
}

export interface ExamMatrix {
  id: string
  tenMaTran: string
  loaiKiemTra: 'KTGKI' | 'KTCKI' | 'KTGKII' | 'KTCKII'
  lop: number
  cacChuong: number[]

  rows: ExamMatrixRow[]

  thoiGianLamBai: number    // phút
  diemDat: number           // %

  createdAt: Date
  updatedAt: Date
}

// Quy tắc tính điểm
export const DIEM_MOI_CAU = {
  TN: 0.25,      // Trắc nghiệm nhiều lựa chọn
  DS: 1.0,       // Đúng sai (4 lệnh)
  TL: 0.5        // Trả lời ngắn
} as const

// Content node cho sidebar
export interface ContentNode {
  type: 'chuong' | 'bai' | 'dang'
  lop: number
  chuong: number
  bai?: number
  dang?: string
  label: string
  hasQuestions?: boolean
  questionCount?: number
}

// Validation result
export interface ValidationResult {
  valid: boolean
  errors: string[]
  warnings?: string[]
}

